"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSerializedWidgetConfig = exports.getSelectedColor = exports.getWidgetColumns = exports.getWidgetSelectedColumn = exports.selectWidgetConfig = void 0;

var _reselect = require("reselect");

var _exposedHooks = require("@widget-editor/widget-editor/lib/exposed-hooks");

var _selectors = require("@widget-editor/shared/lib/modules/editor/selectors");

var _selectors2 = require("@widget-editor/shared/lib/modules/theme/selectors");

var SINGLE_COLOR_OPTION = {
  alias: "Single color",
  name: "Single color",
  identifier: "___single_color"
};

var getColumnDataType = function getColumnDataType(columnName, fields) {
  var o = null;

  if (!fields) {
    return null;
  }

  fields.forEach(function (field) {
    if (field.columnName === columnName) {
      o = field.type;
    }
  });
  return o;
};

var selectWidgetConfig = function selectWidgetConfig(state) {
  return state.widgetConfig;
};

exports.selectWidgetConfig = selectWidgetConfig;

var getConfiguration = function getConfiguration(state) {
  return state.configuration;
};

var getDataset = function getDataset(state) {
  return state.editor.dataset;
};

var getFilters = function getFilters(state) {
  return state.filters;
};

var getFields = function getFields(state) {
  return state.editor.fields;
};

var getProps = function getProps(_, props) {
  return props ? props : null;
};

var getWidgetSelectedColumn = (0, _reselect.createSelector)([getConfiguration, getDataset], function (configuration, dataset) {
  if (!dataset || !dataset.id || !dataset.attributes || !dataset.attributes.metadata) {
    return null;
  }

  var value = dataset.attributes.metadata[0].attributes.columns[configuration.value.name];
  return _objectSpread({}, value, {
    identifier: configuration.value.name
  });
});
exports.getWidgetSelectedColumn = getWidgetSelectedColumn;
var getWidgetColumns = (0, _reselect.createSelector)([getConfiguration, getDataset, getFields, getProps], function (configuration, dataset, fields, props) {
  var _dataset$attributes$m;

  if (!dataset || !dataset.hasOwnProperty("id") || !dataset.hasOwnProperty("attributes") || !dataset.attributes.hasOwnProperty("widgetRelevantProps")) {
    return [];
  }

  var relevantProps = dataset.attributes.widgetRelevantProps;
  var datasetMeta = (_dataset$attributes$m = dataset.attributes.metadata) === null || _dataset$attributes$m === void 0 ? void 0 : _dataset$attributes$m[0];
  var columns = [];

  if (fields) {
    columns = fields.map(function (field) {
      var _datasetMeta$attribut, _datasetMeta$attribut2;

      return _objectSpread({}, (_datasetMeta$attribut = datasetMeta === null || datasetMeta === void 0 ? void 0 : (_datasetMeta$attribut2 = datasetMeta.attributes.columns) === null || _datasetMeta$attribut2 === void 0 ? void 0 : _datasetMeta$attribut2[field.columnName]) !== null && _datasetMeta$attribut !== void 0 ? _datasetMeta$attribut : {}, {
        identifier: field.columnName,
        name: field.columnName,
        type: getColumnDataType(field.columnName, fields)
      });
    });

    if ((relevantProps === null || relevantProps === void 0 ? void 0 : relevantProps.length) > 0) {
      columns = columns.filter(function (column) {
        return relevantProps.indexOf(column.name) !== -1;
      });
    }
  }

  if (configuration.chartType === "pie") {
    return columns;
  }

  if (props && props.colorDimention === true) {
    return [SINGLE_COLOR_OPTION].concat(_toConsumableArray(columns));
  }

  return columns;
});
exports.getWidgetColumns = getWidgetColumns;
var getSelectedColor = (0, _reselect.createSelector)([getConfiguration, getDataset, getWidgetColumns], function (configuration, dataset, widgetColumns) {
  var _configuration$color;

  if (!dataset || !dataset.id || !dataset.attributes || !dataset.attributes.metadata) {
    return null;
  }

  if (configuration.chartType === "pie") {
    var _configuration$catego;

    var _colorColumn = ((_configuration$catego = configuration.category) === null || _configuration$catego === void 0 ? void 0 : _configuration$catego.name) ? widgetColumns.find(function (column) {
      return column.identifier === configuration.category.name;
    }) : null;

    return _colorColumn || null;
  }

  var colorColumn = ((_configuration$color = configuration.color) === null || _configuration$color === void 0 ? void 0 : _configuration$color.name) ? widgetColumns.find(function (column) {
    return column.identifier === configuration.color.name;
  }) : null;
  return colorColumn || SINGLE_COLOR_OPTION;
});
exports.getSelectedColor = getSelectedColor;
var selectSerializedWidgetConfig = (0, _reselect.createSelector)([selectWidgetConfig, _selectors.selectIsWidgetAdvanced, _selectors2.selectScheme], function (widgetConfig, isAdvancedWidget, scheme) {
  var _ref = (0, _exposedHooks.getLocalCache)(),
      adapter = _ref.adapter;

  var config = _objectSpread({}, widgetConfig !== null && widgetConfig !== void 0 ? widgetConfig : {});

  if (isAdvancedWidget) {
    return config;
  } // When the user is creating or editing a widget, the data is embedded within the widgetConfig
  // This function replaces it by the URL of the data


  if (config.data && Array.isArray(config.data)) {
    config.data = config.data.map(function (data) {
      if (data.name === 'table') {
        var _data$transform;

        return {
          name: 'table',
          transform: (_data$transform = data.transform) !== null && _data$transform !== void 0 ? _data$transform : null,
          format: {
            type: 'json',
            property: 'data'
          },
          url: adapter.getDataUrl()
        };
      }

      return data;
    });
  } // We serialise the selected scheme


  config.config = adapter.getSerializedScheme(scheme);
  return config;
});
exports.selectSerializedWidgetConfig = selectSerializedWidgetConfig;